import styled from '@emotion/styled'


// example of styled button component
// this pattern can be used for any html elements
const StyledButton = styled.button`
  background-color: turquoise;
  padding: 10px;
  color: white;
  cursor: pointer;
  width: 100%;
`

// define a custom component to style
// must pass className prop for styling to work
const MyComponent = ({ className }) => (
  <div className={className}>
    Styled Custom Component
  </div>
)

// style the component here
const StyledMyComponent = styled(MyComponent)`
  color: #61dafb;
  background-color: rgba(0, 250, 255, 0.2);
  padding: 10px;
  border-radius: 6px;
`


const StyleDemo = () => {
  return (
    <>

      <StyledButton>This my styled button component.</StyledButton>

      <StyledMyComponent />

    </>
  );
}

export default StyleDemo;
